module.exports = __webpack_public_path__ + "static/scott-72b47b8d2bf95a13d471bac6fed99138.png";